import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const Home = () => {
  return (
    <>
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid>
          <Row className="justify-content-center" style={{minHeight:'90vh'}}>
            <Col xs="12" lg="12" className='mt-1 align-self-center text-center'>
              <h1>Welcome to the User Management System</h1>
              <p className='py-4'>Use the navigation bar to access different sections of the application.</p>
              <div className={styles.links}>
                <Link to="/dashboard" className='link_inl_btn'>Go to Dashboard</Link>
                <Link to="/messages" className='link_out_btn'>Go to Messages</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    {/* <div className={styles.home}>
      <div className={styles.content}>
        <h1>Welcome to the User Management System</h1>
        <p>Use the navigation bar to access different sections of the application.</p>
        <div className={styles.links}>
          <Link to="/dashboard" className={styles.linkButton}>Go to Dashboard</Link>
          <Link to="/messages" className={styles.linkButton}>Go to Messages</Link>
        </div>
      </div>
    </div> */}
    </>
  );
};

export default Home;
